<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-forma-recebimento') {
            next({ name: 'ven-forma-recebimento-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-forma-recebimento') {
            this.$router.push({ name: 'ven-forma-recebimento-list' });
        }
    },
};
</script>
